<div style="margin-left: 10px;">

    <button mat-button [matMenuTriggerFor]="langMenu">
           <span  *ngIf="lang=='en'"><i class="fa fa-globe"></i>تغيير اللغة </span>
           <span *ngIf="lang=='ar'"><i class="fa fa-globe"></i> Language </span>
<!--            <span *ngIf="lang=='en'"> EN</span>-->
<!--            <span *ngIf="lang=='ar'"> العربية </span>-->
    </button>

    <mat-menu #langMenu="matMenu">
    <a href="/en-US/web/home" (click)="changeToEnglish() " mat-menu-item>English</a>
    <a href="/ar/web/home" (click)="changeToArabic()" mat-menu-item>العربية</a>
    </mat-menu>


</div>
